// Axios
import Axios from "./axios"

export const registerUser = (values) => {
    return new Promise((resolve, reject) => {
        const data = Axios.post(`/user/register`, values)
        resolve(data)
    })
}